module.exports = __webpack_public_path__ + "img/bigdata-1.f6e78223.png";